namespace RedBullMOBILE360.Utilities {
    export class ReAuthenticateNumbersColumns {
        static columnsKey = 'Utilities.ReAuthenticateNumbers';
    }
}